export const LOADING_NOTE = "LOADING_NOTE";
export const GET_NOTE_LIST = "GET_NOTE_LIST";
export const REMOVE_NOTE = "REMOVE_NOTE";
export const ADD_NOTE = "ADD_NOTE";
export const UPDATE_NOTE = "UPDATE_NOTE";
export const GET_NOTE_BY_ID = "GET_NOTE_BY_ID";
export const GET_NOTE_BY_LEADID = "GET_NOTE_BY_LEADID";